"use strict";
// This is an auto-generated file. Please do not edit directly.
// For instructions on editing source .json files, please see:
// https://git.hubteam.com/HubSpot/UIComponents/tree/master/HubStyleTokens
// ***********************************************************************
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HOVERLAY_OPACITY = exports.TOOLTIP_SHADOW = exports.TABLE_CELL_VERTICAL_ALIGNMENT = exports.TABLE_HEADER_VERTICAL_ALIGNMENT = exports.TABLE_HEADER_FONT_WEIGHT = exports.INPUT_VERTICAL_ALIGNMENT = exports.HEADING_CASE6 = exports.HEADING_WEIGHT7 = exports.HEADING_WEIGHT6 = exports.HEADING_WEIGHT5 = exports.HEADING_WEIGHT4 = exports.HEADING_WEIGHT3 = exports.HEADING_WEIGHT2 = exports.HEADING_WEIGHT1 = exports.HEADING_FONT_SMOOTHING = exports.FALLBACK_FONT_STACK = exports.WEB_FONT_ITALIC_WEIGHT = exports.WEB_FONT_DEMI_BOLD_WEIGHT = exports.WEB_FONT_MEDIUM_WEIGHT = exports.WEB_FONT_BOLD_WEIGHT = exports.WEB_FONT_REGULAR_WEIGHT = exports.WEB_FONT_ITALIC = exports.WEB_FONT_DEMI_BOLD = exports.WEB_FONT_MEDIUM = exports.WEB_FONT_BOLD = exports.WEB_FONT_REGULAR = exports.CODE_FONT_WEIGHT = exports.CODE_FONT_FAMILY = exports.CODE_FALLBACK_FONT_STACK = exports.ICON_FONT_FAMILY = void 0;
var ICON_FONT_FAMILY = 'spacesword';
exports.ICON_FONT_FAMILY = ICON_FONT_FAMILY;
var CODE_FALLBACK_FONT_STACK = 'Consolas, Monaco, Courier New, monospace';
exports.CODE_FALLBACK_FONT_STACK = CODE_FALLBACK_FONT_STACK;
var CODE_FONT_FAMILY = 'Source Code Pro';
exports.CODE_FONT_FAMILY = CODE_FONT_FAMILY;
var CODE_FONT_WEIGHT = '500';
exports.CODE_FONT_WEIGHT = CODE_FONT_WEIGHT;
var WEB_FONT_REGULAR = 'Avenir Next W02';
exports.WEB_FONT_REGULAR = WEB_FONT_REGULAR;
var WEB_FONT_BOLD = 'Avenir Next W02';
exports.WEB_FONT_BOLD = WEB_FONT_BOLD;
var WEB_FONT_MEDIUM = 'Avenir Next W02';
exports.WEB_FONT_MEDIUM = WEB_FONT_MEDIUM;
var WEB_FONT_DEMI_BOLD = 'Avenir Next W02';
exports.WEB_FONT_DEMI_BOLD = WEB_FONT_DEMI_BOLD;
var WEB_FONT_ITALIC = 'Avenir Next W02';
exports.WEB_FONT_ITALIC = WEB_FONT_ITALIC;
var WEB_FONT_REGULAR_WEIGHT = '400';
exports.WEB_FONT_REGULAR_WEIGHT = WEB_FONT_REGULAR_WEIGHT;
var WEB_FONT_BOLD_WEIGHT = '700';
exports.WEB_FONT_BOLD_WEIGHT = WEB_FONT_BOLD_WEIGHT;
var WEB_FONT_MEDIUM_WEIGHT = '500';
exports.WEB_FONT_MEDIUM_WEIGHT = WEB_FONT_MEDIUM_WEIGHT;
var WEB_FONT_DEMI_BOLD_WEIGHT = '600';
exports.WEB_FONT_DEMI_BOLD_WEIGHT = WEB_FONT_DEMI_BOLD_WEIGHT;
var WEB_FONT_ITALIC_WEIGHT = '400';
exports.WEB_FONT_ITALIC_WEIGHT = WEB_FONT_ITALIC_WEIGHT;
var FALLBACK_FONT_STACK = 'Helvetica, Arial, sans-serif';
exports.FALLBACK_FONT_STACK = FALLBACK_FONT_STACK;
var HEADING_FONT_SMOOTHING = 'antialiased';
exports.HEADING_FONT_SMOOTHING = HEADING_FONT_SMOOTHING;
var HEADING_WEIGHT1 = 'bold';
exports.HEADING_WEIGHT1 = HEADING_WEIGHT1;
var HEADING_WEIGHT2 = 'regular';
exports.HEADING_WEIGHT2 = HEADING_WEIGHT2;
var HEADING_WEIGHT3 = 'medium';
exports.HEADING_WEIGHT3 = HEADING_WEIGHT3;
var HEADING_WEIGHT4 = 'demibold';
exports.HEADING_WEIGHT4 = HEADING_WEIGHT4;
var HEADING_WEIGHT5 = 'demibold';
exports.HEADING_WEIGHT5 = HEADING_WEIGHT5;
var HEADING_WEIGHT6 = 'demibold';
exports.HEADING_WEIGHT6 = HEADING_WEIGHT6;
var HEADING_WEIGHT7 = 'demibold';
exports.HEADING_WEIGHT7 = HEADING_WEIGHT7;
var HEADING_CASE6 = 'uppercase';
exports.HEADING_CASE6 = HEADING_CASE6;
var INPUT_VERTICAL_ALIGNMENT = 'middle';
exports.INPUT_VERTICAL_ALIGNMENT = INPUT_VERTICAL_ALIGNMENT;
var TABLE_HEADER_FONT_WEIGHT = 'medium';
exports.TABLE_HEADER_FONT_WEIGHT = TABLE_HEADER_FONT_WEIGHT;
var TABLE_HEADER_VERTICAL_ALIGNMENT = 'middle';
exports.TABLE_HEADER_VERTICAL_ALIGNMENT = TABLE_HEADER_VERTICAL_ALIGNMENT;
var TABLE_CELL_VERTICAL_ALIGNMENT = 'middle';
exports.TABLE_CELL_VERTICAL_ALIGNMENT = TABLE_CELL_VERTICAL_ALIGNMENT;
var TOOLTIP_SHADOW = '0 3px 8px rgba(0, 0, 0, .1)';
exports.TOOLTIP_SHADOW = TOOLTIP_SHADOW;
var HOVERLAY_OPACITY = '0.85';
exports.HOVERLAY_OPACITY = HOVERLAY_OPACITY;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/HubStyleTokens/static-2.2463/js/misc.js
// module id = 51
// module chunks = 209 210 211 212